import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=27961066"
import script from "./AssessmentForm.vue?vue&type=script&lang=js"
export * from "./AssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=27961066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports